import type { ProjectPlan } from "@/types/api";

export function isPlanArchived(plan: ProjectPlan): boolean {
  return plan.deleted_at != null;
}
